var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("cargo-repeat-value-select", {
        attrs: {
          disabled: _vm.disabled,
          options: _vm.options,
          "allow-create": "",
          "label-field": "no",
          "value-field": "no",
          "unique-field": "no",
          "match-of-repeat-value": _vm.matchOfCNpt,
          filterable: "",
          clearable: ""
        },
        on: {
          change: function($event) {
            return _vm.onChange("cNptNo")
          }
        },
        model: {
          value: _vm.job.cNptNo,
          callback: function($$v) {
            _vm.$set(_vm.job, "cNptNo", $$v)
          },
          expression: "job.cNptNo"
        }
      }),
      _c("el-input", {
        staticStyle: { "margin-top": "5px" },
        attrs: { disabled: _vm.disabled, type: "textarea", rows: 3 },
        on: {
          change: function($event) {
            return _vm.onChange("cNptName")
          }
        },
        model: {
          value: _vm.job.cNptName,
          callback: function($$v) {
            _vm.$set(_vm.job, "cNptName", $$v)
          },
          expression: "job.cNptName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }